<template>
    <b-modal v-model="visible" title="Transférer vers une armoire" size="lg" hide-footer :no-close-on-backdrop="saving || uncertain" :no-close-on-esc="saving || uncertain" :hide-header-close="saving || uncertain" @hide="protectSave">
        <p v-if="loading" role="status">Chargement des armoires…</p>
        <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
        <form v-if="ready" @submit.prevent="save">
            <div class="transfer-summary mb-3">
                <strong>{{ batch.libelle }}</strong>
                <p class="mb-1">{{ batch.stock_name }} · Lot {{ batch.lot }}</p>
                <p class="mb-1">Péremption : {{ batch.expires_on.split('-').reverse().join('/') }}</p>
                <p class="mb-0">{{ formatNumberCompact(batch.closed_units) }} unité(s) fermée(s) disponible(s) · {{ formatNumberCompact(batch.doses_per_unit) }} dose(s) par unité</p>
            </div>
            <fieldset :disabled="saving || uncertain">
                <div class="row">
                    <div class="col-md-8 form-group">
                        <label for="transfer-service">Service / armoire *</label>
                        <select id="transfer-service" v-model="form.service_id" class="form-control" required>
                            <option value="">Choisir le service destinataire</option>
                            <option v-for="service in services" :key="service.id" :value="service.id">{{ service.name }} — {{ service.stock_name }}</option>
                        </select>
                    </div>
                    <div class="col-md-4 form-group">
                        <label for="transfer-units">Unités fermées à transférer *</label>
                        <input id="transfer-units" v-model="form.units" type="number" min="1" :max="Math.min(100000, Number(batch.closed_units))" step="1" class="form-control" required>
                    </div>
                </div>
            </fieldset>
            <p>Le lot et sa péremption sont conservés. Ce transfert ne constitue pas une administration et ne crée aucune facture.</p>
            <div class="ui-modal-actions">
                <button type="button" class="btn btn-outline-secondary" :disabled="saving || uncertain" @click="visible = false">Annuler</button>
                <button type="submit" class="btn btn-primary" :disabled="saving">{{ saving ? 'Transfert…' : (uncertain ? 'Réessayer le même transfert' : 'Transférer') }}</button>
            </div>
        </form>
        <div v-else-if="!loading" class="ui-modal-actions"><button type="button" class="btn btn-outline-secondary" @click="visible = false">Fermer</button></div>
    </b-modal>
</template>
<script>
import Api from '@/api/api'
import { newVaccineRequestKey } from '@/utils/vaccine-catalogue'
import { formatNumberCompact } from '@/utils/number-display'
export default {
    name: 'VaccineTransfer',
    data: () => ({visible:false,loading:false,ready:false,saving:false,uncertain:false,error:'',batch:{},services:[],form:{service_id:'',units:''},key:'',pending:null,sequence:0}),
    computed: {
        identity() {const a=this.$store.getters.authInfo;const r=this.$store.getters.activeRole;return `${a && a.user && a.user.id}:${r && r.id}`},
    },
    watch: {identity() {this.sequence++;this.visible=false;this.ready=false;this.saving=false;this.uncertain=false;this.batch={};this.pending=null;this.services=[];this.form={service_id:'',units:''}}},
    beforeDestroy() {this.sequence++},
    methods: {
        formatNumberCompact,
        protectSave(e) {if(this.saving || this.uncertain)e.preventDefault()},
        async open(batch) {
            if(this.saving || this.uncertain)return
            const sequence=++this.sequence
            this.batch={...batch};this.form={service_id:'',units:''};this.pending=null;this.key=newVaccineRequestKey()
            this.visible=true;this.loading=true;this.ready=false;this.error='';this.services=[]
            try {
                const r=await Api().get('/v1/vaccines/transfer-options')
                if(sequence!==this.sequence)return
                if(Number(batch.stock_id)!==Number(r.data.source.id) || Number(batch.closed_units)<1 || batch.expires_on<=r.data.today) {
                    this.error='Choisissez un lot non périmé, disponible à la pharmacie centrale.';return
                }
                this.services=r.data.services
                if(!this.services.length) {this.error='Aucun service actif avec une armoire disponible. Configurez son armoire dans les paramètres des unités de soins.';return}
                this.ready=true
            }catch(e){if(sequence===this.sequence)this.error=this.message(e)}
            finally{if(sequence===this.sequence)this.loading=false}
        },
        message(e) {
            const status=e.response && e.response.status
            if(status===422)return 'Vérifiez le lot, le service et le nombre entier d’unités à transférer.'
            if(status===409)return 'Transfert refusé : vérifiez le stock disponible, la péremption et l’armoire. Fermez puis actualisez les lots.'
            if(status===401 || status===403)return 'Votre rôle actif ne permet pas ce transfert.'
            if(status===404 || status===503)return 'Les transferts vaccinaux ne sont pas activés ou configurés.'
            return 'Réponse serveur non confirmée. Réessayez le même transfert sans fermer cette fenêtre.'
        },
        async save() {
            if(this.saving || !this.ready)return
            const sequence=this.sequence;this.saving=true;this.error=''
            if(!this.uncertain)this.pending={request_key:this.key,source_batch_id:Number(this.batch.id),service_id:Number(this.form.service_id),units:Number(this.form.units)}
            try {
                const r=await Api().post('/v1/vaccines/transfers',this.pending)
                if(sequence!==this.sequence)return
                this.saving=false;this.uncertain=false;this.visible=false;this.$emit('saved',r.data)
            }catch(e){
                if(sequence!==this.sequence)return
                const status=e.response && e.response.status
                this.uncertain=!status || status>=500;this.error=this.message(e)
            }finally{if(sequence===this.sequence)this.saving=false}
        },
    },
}
</script>
<style scoped>
.transfer-summary {padding:16px;background:#f4f7fd;border:1px solid #d8e2f5;border-radius:14px;color:var(--ui-text-secondary,#273449);}
label {font-weight:600;color:var(--ui-text-secondary,#273449);}
.form-control {min-height:44px;border:1px solid #9aaac1;border-radius:14px;color:var(--ui-text,#172033);}
fieldset {min-width:0;}
</style>
